//src/components/TableHeader.tsx
import React from 'react';
import { Input, Button } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

type Props = {
  icon?: React.ReactNode;
  title: React.ReactNode;
  chips?: React.ReactNode;
  totalLabel?: string;
  totalValue?: React.ReactNode;
  searchPlaceholder?: string;
  searchValue?: string;
  onSearchChange?: (v: string) => void;
  onResetColumns?: () => void;
  exportButton?: React.ReactNode;
  actionButton?: React.ReactNode;
};

const TableHeader: React.FC<Props> = ({
  icon,
  title,
  chips,
  totalLabel,
  totalValue,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  onResetColumns,
  exportButton,
  actionButton,
}) => {
  return (
    <div className="stat-h">
      <div className="stat-h-left">
        {icon ? <span className="stat-card__icon">{icon}</span> : null}
        <span className="stat-card__title">{title}</span>
      </div>

      <div className="stat-h-middle">{chips}</div>

      <div className="stat-h-right">
        <div className="stat-h-total-row">
          {actionButton}
          {(totalLabel != null || totalValue != null) && (
            <span className="stat-card__chip stat-card__chip--total header-action-btn">
              {totalLabel}: {totalValue}
            </span>
          )}
        </div>

        {onSearchChange && (
          <div className="orders-search">
            <Input
              allowClear
              size="middle"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              prefix={<SearchOutlined />}
            />
          </div>
        )}
      </div>

      <div className="stat-h-right">
        {onResetColumns && (
          <Button
            className="header-action-btn"
            type="default"
            icon={<ReloadOutlined />}
            onClick={onResetColumns}
          >
            Сбросить колонки
          </Button>
        )}
        {exportButton}
      </div>
    </div>
  );
};

export default TableHeader;
